// Date 2020-09-18 09:17:42

import emEntityListView from "@/components/em/EmEntity/ListView";
import emEntityEditView from "@/components/em/EmEntity/EditView";
import emLevelTreeListView from "@/components/em/EmLevelTree/ListView";

import sithMesAndonTaskList from "@/views/sithMes/andon/SithMesAndonTaskList.vue";
import sithMesAndonTaskEdit from "@/views/sithMes/andon/SithMesAndonTaskEdit.vue";
import sithMesAndonTaskExecute from "@/views/sithMes/andon/SithMesAndonTaskExecute.vue";
import sithMesAndonTypePositionList from "@/views/sithMes/andon/SithMesAndonTypePositionList.vue";
import sithMesAndonTypePositionEdit from "@/views/sithMes/andon/SithMesAndonTypePositionEdit.vue";
const metaObject = {
    requiresAuth: true,
    roles: ['mmf']
};

export default [
    //公用组件注册
    {
        path: "/sithMes/andon/sithMesAndonLightLevel/list",
        name: "sithMesAndonLightLevelList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonLightLevel/edit",
        name: "sithMesAndonLightLevelEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonPosition/list",
        name: "sithMesAndonPositionList",
        component: emLevelTreeListView,
        props: (route) => ({
            prop_inline: route.query.inline
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonPosition/edit",
        name: "sithMesAndonPositionEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonTaskSchedule/list",
        name: "sithMesAndonTaskScheduleList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonTaskSchedule/edit",
        name: "sithMesAndonTaskScheduleEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonType/list",
        name: "sithMesAndonTypeList",
        component: emEntityListView,
        props: (route) => ({
            prop_inline: route.query.inline
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonType/edit",
        name: "sithMesAndonTypeEdit",
        component: emEntityEditView,
        meta: metaObject
    },
    //自定义页面注册
    {
        path: "/sithMes/andon/sithMesAndonTaskList",
        name: "sithMesAndonTaskList",
        component: sithMesAndonTaskList,
        props: (route) => ({
            prop_inline: route.query.inline
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonTaskExecute",
        name: "sithMesAndonTaskExecute",
        component: sithMesAndonTaskExecute,
        props: (route) => ({
            prop_inline: route.query.inline
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonTaskEdit",
        name: "sithMesAndonTaskEdit",
        component: sithMesAndonTaskEdit,
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonTypePositionList",
        name: "sithMesAndonTypePositionList",
        component: sithMesAndonTypePositionList,
        props: (route) => ({
            prop_inline: route.query.inline
        }),
        meta: metaObject
    },
    {
        path: "/sithMes/andon/sithMesAndonTypePositionEdit",
        name: "sithMesAndonTypePositionEdit",
        component: sithMesAndonTypePositionEdit,
        meta: metaObject
    }
]